import { ITkFakeTableLineProps } from "../../type/componentsType/TkFakeTableLine";
import TkPropertyMessageGet from "../../utils/TkPropertyMessageGet";
import { AbolitionReason } from "../../assets/data/Constants";
import { TkGetCodeList } from "../../utils/TkGetCode";

/**
 * フォームの情報
 */
const fakeTableList: ITkFakeTableLineProps[] = [
  {
    title: "理由の選択",
    keyword: "reason",
    type: "selectForm",
    requiredIcon: true,
    selectPropsList: TkGetCodeList(AbolitionReason),
    helpicon: true,
    helpText:
      "「ア 廃止」、「イ 休止」、「ウ 経営移管」のうちから選んでください。",
  },
  {
    title: "廃止・休止・経営移管年月日",
    keyword: "obsoleteDate",
    type: "date",
    minDate: new Date("1900/01/01"),
    maxDate: new Date("2099/12/31"),
    requiredIcon: true,
    helpicon: true,
    helpText:
      "経営していた最終日を登録してください。直接入力していただくか、「カレンダーボタン」にて日付を選択してください。",
  },
  {
    title: "廃止・休止が確認できる書類の添付",
    keyword: "fileUpload",
    type: "fileUpload",
    requiredIcon: true,
    helpicon: true,
    helpText: (
      <>
        以下の確認事項が明記された書類の添付が必要です。
        <br />
        ①施設・事業の名称　②所在地　③施設・事業の種類（申出施設等については不要）　④廃止・休止年月日
        <br />
        <br />
        添付書類として以下のいずれかを添付してください。
        <br />
        （１）「廃止・休止届受理通知書」（写）
        <br />
        （２）受理印等のある「廃止・休止届」（写）
        <br />
        （３）その他、業務委託契約書等（写）
        <br />
        <br />
        なお、上記の書類がない場合は、都道府県知事等が発行する証明書等を添付してください。
        <br />
        ※法令等により許認可・届出の必要がない場合のみ、次のいずれかの書類でも可能です。
        <br />
        （１）法人の定款（写）
        <br />
        （２）定款変更申込書（写）及びその他の書類
      </>
    ),
  },
  {
    title: "経営移管後の共済契約者番号",
    keyword: "aContractorNo",
    type: "label",
    showLine: false,
  },
  {
    title: "経営移管後の共済契約者名",
    keyword: "aCorpname",
    type: "label",
    requiredIcon: true,
    showLine: false,
    inputProps: { minLength: 1, maxLength: 85 },
  },
];

const schema = {
  common: {
    reason: {
      required: TkPropertyMessageGet("TKMSG_SCR0044E"),
    },
    obsoleteDate: {
      required: TkPropertyMessageGet("TKMSG_SCR0043E"),
    },
    fileUpload: {
      required: TkPropertyMessageGet("TKMSG_SCR0044E"),
    },
  },
  contractorNo: {
    aContractorNo: {
      pattern: {
        value: /^[0-9]*$/,
        message: TkPropertyMessageGet("TKMSG_SCR0053E"),
      },
      maxLength: {
        value: 6,
        message: TkPropertyMessageGet("TKMSG_SCR0077E", "6"),
      },
      minLength: {
        value: 6,
        message: TkPropertyMessageGet("TKMSG_SCR0077E", "6"),
      },
    },
    aCorpname: {
      required: TkPropertyMessageGet("TKMSG_SCR0043E"),
      pattern: {
        // eslint-disable-next-line no-control-regex
        value: /^[^\x00-\x08\x0B\x0C\x0E-\x1F\x7F -~｡-ﾟ]+$/,
        message: TkPropertyMessageGet("TKMSG_SCR0061E"),
      },
    },
  },
};

const stepperData = [
  "施設選択",
  "対象施設一覧/施設情報・異動状況登録",
  "内容確認",
  "機構へ提出",
];

const contextText = `入力された解除年月日以降の退職(予定)年月日・異動情報(配置換え)が入力されている職員が存在します。<このまま廃止・休止・経営移管の申請を進めると、退職(予定)年月日・異動情報(配置換え)が削除されます。`;

export { stepperData, fakeTableList, schema, contextText };
